<template>
  <div class="flex flex-col gap-10">
    <div class="mx-auto">
      <p class="text-gray-900 lg:text-[36px] text-[24px] lg:mx-0 mx-[20px] font-extrabold">Konferenci pro vás připravuje Shopcamp s.r.o.</p>
    </div>
<div class="mx-[10%] gap-[30px] hidden lg:flex flex-row justify-between">
  <Card v-for="organizer in organizers" :organizer="organizer" />
</div>
    <div class="lg:hidden ml-[20px]">
      <Carousel :organizers="organizers"></Carousel>
    </div>
  </div>
</template>

<script setup>
import Card from "./Card.vue";
import Carousel from "./Carousel.vue";

const organizers = [
  {
    photoLink: '/assets/sara.png',
    role: 'Hlavní organizátorka',
    name: "Sára Procházková",
    linkedIn: 'https://www.linkedin.com'
  },
  {
    photoLink: '/assets/sara.png',
    role: 'Hlavní organizátor',
    name: "Jakub Smolík",
    linkedIn: 'https://www.linkedin.com'
  },
  {
    photoLink: '/assets/sara.png',
    role: 'Garant obsahu',
    name: "Matěj Kapošváry",
    linkedIn: 'https://www.linkedin.com'
  },
  {
    photoLink: '/assets/sara.png',
    role: 'Marketing',
    name: "Petra Štěrbová",
    linkedIn: 'https://www.linkedin.com'
  },
  {
    photoLink: '/assets/sara.png',
    role: 'Marketing',
    name: "Vít Kuldan",
    linkedIn: 'https://www.linkedin.com'
  },
]
</script>

<style scoped>

</style>
